/**
 * Created by comoon on 3/2/16.
 */

var React = require('react');

var {object2class} = require("../util/clazz");

module.exports = React.createClass({
    displayName: "NumberRange",
    getInitialState(){
        return {
            current: this.props.current || 0
        }
    },
    handle_plus(){
        var current = +this.state.current;
        current = current + 1;
        this.props.onChange(current);
        this.setState({current: current});
    },
    handle_minus(){
        var current = +this.state.current;
        current = current - 1;
        this.props.onChange(current);
        this.setState({current: +current});
    },
    componentWillReceiveProps(nextProps){
        if (nextProps.hasOwnProperty('current')) {

            this.setState({current: nextProps.current});
        }
    },
    render(){
        var state = this.state;
        var props = this.props;
        var minusAble = true;
        if (props.hasOwnProperty('min') && (+props.min >= state.current)) {
            minusAble = false;
        }
        var increaseAble = true;
        if (!props.hasOwnProperty('max') && (+props.max <= state.current)) {
            increaseAble = false;
        }
        var nrClazz = object2class({
            'passed': this.props.className,
            'comoon-number-range': true
        });
        return (
            <span className={nrClazz}>
                <span className="nr-minus" onClick={minusAble ? this.handle_minus : null}/>
                <span className="nr-current">{state.current}</span>
                <span className="nr-plus" onClick={increaseAble ? this.handle_plus : null}/>
            </span>
        );
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/cutil/NumberRange.jsx
 **/